export const REDUCER_NAME = 'SEND_DASHBOARD';


